export default __webpack_public_path__ + "static/media/client.ace23f55.jpeg";